import { PageBadge } from "../recordDefinition.types";

// The colours legacy StatusBadge gave CommunicationActivityStatus.
const Statuses: Record<number, { label: string; variant: string }> = {
  0: { label: "Open", variant: "info" },
  1: { label: "Completed", variant: "success" },
  2: { label: "Cancelled", variant: "danger" },
  3: { label: "Scheduled", variant: "warning" },
};

export const communicationActivityPageBadges: PageBadge[] = [
  {
    id: "state",
    label: (record) => Statuses[record.statecode as number]?.label ?? "",
    variant: (record) => Statuses[record.statecode as number]?.variant ?? "info",
  },
];
